import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils'
import { type UseQueryRequestOptions } from '~/ui/hooks/utils/service/use-query-request'

type MovementStatus = 'success' | 'failed' | 'processing'

export type MarketMovementStatusResponse = { status: MovementStatus }

async function fetchMarketMovementStatus({ accountId, movementId }: { accountId: string; movementId?: string }) {
  const { data } = await httpClientBanking<MarketMovementStatusResponse>({
    url: `/investments/accounts/${accountId}/storefront/movements/${movementId}`,
    method: 'GET'
  })
  return data
}

export function useFetchMarketMovementStatus({
  accountId,
  movementId,
  config
}: {
  accountId: string
  movementId?: string
  config?: UseQueryRequestOptions<MarketMovementStatusResponse, unknown, true>
}) {
  const {
    data: movementStatusData,
    isLoading: isMovementStatusLoading,
    isError: isMovementStatusError,
    isSuccess: isMovementStatusSuccess
  } = useQueryRequest<MarketMovementStatusResponse, unknown, true>(
    ['fetchMarketMovementStatus', accountId, movementId],
    () => fetchMarketMovementStatus({ accountId, movementId }),
    config
  )
  return {
    movementStatusData,
    isMovementStatusLoading,
    isMovementStatusError,
    isMovementStatusSuccess
  }
}
